import { View } from "@-/com.npmjs.react-native";
import { Switch } from "@-/dev.improve.haniverse.components.ui.switch";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { useUpdateUserSettings } from "@-/dev.improve.haniverse.lib.user.settings.update";

/**
 * Stateful wrapper that lets the "Pinyin Tone Colors" onboarding slide
 * (`slides/000/008-pinyin-tone-colors.mdx`) render a live tone-colors switch
 * above its mnemonic table.
 *
 * Mirrors the sibling {@link SlideHanziScriptToggle}: MDX is declarative and
 * can't own `checked`/`onCheckedChange`, so this wrapper sources the current
 * value from {@link AppLayoutContext} and persists the choice through
 * {@link useUpdateUserSettings} — the same `isToneColorsEnabled` field the
 * Settings → Tone Colors page writes, so a change here is the real account-wide
 * preference rather than throwaway local state. The field defaults to `true`
 * (see `DEFAULT_USER_SETTINGS`), so the switch reads as on until toggled off.
 */
export function SlideToneColorsToggle() {
  const { isToneColorsEnabled } = useActorUser();
  const updateUserSettingsMutation = useUpdateUserSettings();

  return (
    <View className="flex-row items-center justify-between gap-3 rounded-xs border border-border px-4 py-3">
      <Text className="flex-1 text-base font-semibold text-foreground">Enable Tone Colors</Text>
      <Switch
        checked={isToneColorsEnabled}
        onCheckedChange={(checked: boolean) => {
          if (checked !== isToneColorsEnabled) {
            updateUserSettingsMutation.mutate({ isToneColorsEnabled: checked });
          }
        }}
      />
    </View>
  );
}
